// 获取用户信息
export const GETUSERINFO = 'get-user-info'

// 登录框显示状态
export const LOGINSTATE = 'login-state'

// 昵称框显示状态
export const RENAMESTATE = 'rename-state'
